import React, { ReactElement } from "react";
import { Price } from "../types/price";
import { match } from "ts-pattern";
import { DiscountChip } from "../DiscountChip/DiscountChip";

export type PriceFromBackground = "neutral05" | "white";

export const formatPrice = (
  price: Price,
  backgroundColor: PriceFromBackground
): string | ReactElement => {
  return match(price)
    .with({ type: "waitlist" }, (p) => p.waitlistLabel)
    .with({ type: "price" }, (p) => p.formattedAmount)
    .with({ type: "discounted" }, (p) => (
      <React.Fragment>
        <DiscountChip lineThrough background={backgroundColor}>
          {p.formattedOriginalAmount}
        </DiscountChip>{" "}
        {p.formattedAmount}
      </React.Fragment>
    ))
    .exhaustive();
};
